import { apiClient } from '@/app/core/services/apiClient.service';
import { OAUTH_CLIENT_ID, OAUTH_TOKEN_ENDPOINT } from '@/app/core/common/config';
import { BaseApiService } from '@/app/shared/services/apis/baseApi.service';

export class AuthApiService extends BaseApiService {
    login() {
        return this.client.post('auth/login');
    }

    async signOut() {
        // logout from API
        const response = await this.client.post('logout');

        // logout from FDID
        if (response.callback_url) {
            window.location.replace(response.callback_url);
        }
    }

    refreshSession(refreshToken, config) {
        const params = {
            grant_type: 'refresh_token',
            refresh_token: refreshToken,
            scope: '',
            client_id: OAUTH_CLIENT_ID,
        };
        return this.client.postBase(OAUTH_TOKEN_ENDPOINT, params, config);
    }

    getToken(payload, config) {
        return this.client.postBase(OAUTH_TOKEN_ENDPOINT, payload, config);
    }

    async devLogin(email) {
        if (import.meta.env.VITE_DEV_LOGIN_ENDPOINT) {
            return this.client.post(import.meta.env.VITE_DEV_LOGIN_ENDPOINT, { email });
        }
    }
}

export const authApi = new AuthApiService(apiClient);
